import Raven from 'raven-js'
import indexOf from 'lodash/indexOf'

let dsnUrl

if (indexOf(['xpstaging.expii.com', 'dogfoodxpstaging.expii.com', 'localhost', 'dogfoodlocal.expii.com'], window.location.hostname) !== -1) {
  dsnUrl = 'https://fca76ac17460481a81e6f70b0e949f30@app.getsentry.com/46755'
} else if (indexOf(['www.expii.com'], window.location.hostname) !== -1) {
  dsnUrl = 'https://b1950101ea3241cc8923fcc2bc03733a@app.getsentry.com/46758'
}

export const sentryEnabled = dsnUrl ? true : false

export function initSentry() {
  if (dsnUrl) {
    Raven.config(dsnUrl, {
      ignoreUrls: [
        /yts\/jsbin\/www-widgetapi/i,
        /graph\.facebook\.com/i,
        /connect\.facebook\.net\/en_US\/all\.js/i,
        /extensions\//i,
        /^chrome:\/\//i,
      ],
    }).install()
  }
}



// WEBPACK FOOTER //
// ./src/util/sentry.js